'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAgentState = undefined;

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _agentStateGetters = require('./agentStateGetters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isAgentState = exports.isAgentState = (0, _curry2.default)(function (agentState, agentRecord) {
  return (0, _agentStateGetters.getAgentState)(agentRecord) === agentState;
});